//#region REACT
import { useState } from "react";
//#endregion 

//#region COMPONENTS
import DashboardHeader from '../Dashboard/DashboardHeader/DashboardHeader';
import MapControl from "./MapControl/MapControl";
import MapFilters from './MapControl/MapFilters';
//#endregion 

//#region STYLES
import './Map.scss';
//#endregion 

export default function Map() {
    const [indicator, setIndicator] = useState(1);
    const [severity, setSeverity] = useState(1);
    const [allHouses, setAllHouses] = useState(false);
    const setSeverityCallback = (value) => { setSeverity(value); };
    const setIndicatorCallback = (value) => { setIndicator(value); };
    const setAllHousesCallback = (value) => { setAllHouses(value); };

    return (
        <div className='Map'>
            <div className='Map__container'>
                <DashboardHeader />
                <div className='Map__container-content'>
                    <MapFilters indicatorSelected={indicator} severitySelected={severity} allHouses={allHouses} setAllHousesCallback={setAllHousesCallback} setIndicatorCallback={setIndicatorCallback} setSeverityCallback={setSeverityCallback}></MapFilters>
                    <MapControl indicatorSelected={indicator} severitySelected={severity} allHouses={allHouses}></MapControl>
                </div>
            </div>
        </div>
    );
}
